import { Outlet } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const RestaurantLayout = () => (
  <>
    <Header />
    <main className="main-content">
      <Outlet />
    </main>
    <Footer />
  </>
);

export default RestaurantLayout;
